import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: 575,

    '.ant-card-actions': {
      padding: '0 16px'
    }
  },

  dashboardCharts: {
    '.ant-card-body': {
      padding: '10px 0'
    }
  },

  flexGrowDashboardCharts: {
    '.ant-card-body': {
      flexGrow: 1
    }
  },

  tasksCards: {
    marginBottom: 16
  },

  listItem: {
    marginInline: 24
  },

  listItemAvatar: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginTop: 6
  }
}))
